import styled from '@emotion/styled';

import theme from '../theme';

const MetaInfo = styled.p`
  font-size: ${theme.fontsize[2]};
  margin-bottom: ${theme.space[4]};
`;

export default MetaInfo;
